import { render } from "./Step2View.vue?vue&type=template&id=18e9b1a7&scoped=true"
import script from "./Step2View.vue?vue&type=script&lang=js"
export * from "./Step2View.vue?vue&type=script&lang=js"

import "./Step2View.vue?vue&type=style&index=0&id=18e9b1a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e9b1a7"]])

export default __exports__